export default "__VITE_ASSET__Byjfx5hQ__"